<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <p class="title titles-head">会员信息</p>
          <div class="totals-box" style="padding: 20px;">
            <div class="detai flex-row">
              <div class="rows" style="margin-right: 10px;">
                <el-avatar
                  v-if="parentForm.memberId && parentForm.orderMemberVO.headImgUrl"
                  :src="headerImg"
                ></el-avatar>
                <el-avatar v-else :src="headerImg"></el-avatar>
              </div>
              <div class="rows" v-if="parentForm.memberId">
                <p>{{ parentForm.orderMemberVO.nickName }} {{ parentForm.orderMemberVO.mobile}}</p>
                <p>账户余额: {{ parentForm.orderMemberVO.walletAmount }}</p>
              </div>
              <div class="rows" v-else>
                <p>门店顾客</p>
              </div>
            </div>
          </div>
          <p class="title">消费信息</p>
          <div class="totals-box" style="padding: 20px;">
            <div class="detai flex-row">
              <el-table :data="parentForm.orderItemVOList" border>
                <el-table-column prop="itemName" label="名称"></el-table-column>
                <el-table-column prop="itemNum" label="数量"></el-table-column>
                <el-table-column prop="itemTypeCn" label="类型"></el-table-column>
                <el-table-column prop="discountAmount" label="优惠"></el-table-column>
                <el-table-column prop="saleAmount" label="实付"></el-table-column>
              </el-table>
            </div>
          </div>

          <p class="title">消费明细</p>
          <div class="totals-box">
            <div class="detail">
              <div class="rows">
                <p>消费合计</p>
                <p>￥{{ parentForm.orderAmount }}</p>
              </div>
              <div class="rows">
                <p>数量</p>
                <p>{{ parentForm.itemNum }}</p>
              </div>
              <div class="rows">
                <p></p>
                <div>
                  商品优惠
                  <span>￥{{ parentForm.discountAmount }}</span>
                </div>
              </div>
              <div class="rows">
                <p class="total">应收</p>
                <p class="amount">{{ parentForm.realPayAmount }}</p>
              </div>
            </div>
          </div>
          <p class="title">收款方式</p>
          <div class="pay-methods flex-row">
            <div
              class="methods active"
              :class="item.show?'active':''"
              v-for="(item,index) in payWayList"
              :key="index"
              @click="payWayFun(item,index)"
            >
              <!-- <p class="imgs el-icon-delete"></p> -->
              <el-image class="imgs" :src="require('../../assets/images/money/xianjin.png')"></el-image>
              <p>{{ item.payName }}</p>
            </div>
          </div>
        </div>
        <div class="drawer-footer">
          <div class="btns">
            <el-button type="danger" class="large-btn" @click="confirmMoney">确定收款</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <div v-if="parentForm.memberId != ''">
      <payDialog title="支付效验" :hide="dialogHide" @changeDialog="savePay"></payDialog>
    </div>
    <pay-form ref="payEditForm" @change="payMoney"></pay-form>
    <quick-top-up ref="topUpForm"></quick-top-up>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import payDialog from "../components/pay-dialog";
import drawer from "../../components/common/drawer";
import payForm from "./pay";
import quickTopUp from "../components/quick-top-up";
import { decrypt, encrypt } from "../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { payDialog, drawer, payForm, quickTopUp },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "收银台",
      dialogHide: false,
      pageHeight: this.$store.getters.MainHeight - 100 + "px",
      form: {
        orderId: "",
        payWay: "cash",
		payWayDescription:"现金",
        verifyCode: "",
        payCheckType: ""
      },
      productImg: require("../../assets/images/notImg.png"),
      headerImg: require("../../assets/images/headerImg.png"),
      // headImg: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      payWayList: [],
      parentForm: {
        memberId: ""
      },
      isPayWayHide: true,
      successImg: require("../../assets/images/money/success.png"),
      notMoneyImg: require("../../assets/images/money/notMoney.png"),
      orderId: "",
      orgForm: "",
      noMoneyStatus: false
    };
  },
  created() {
    // this.init();
  },
  mounted() {},
  methods: {
    handleChangeDrawer() {
      this.addEditShow = false;
    },
    init() {
      this.$on("set", function(org) {
        this.orgForm = org;
        console.log("org: ", org);
        this.addEditShow = true;
        this.$api
          .get(this.$url.orderInfo.get, {
            id: org.id
          })
          .then(res => {
            if (res) {
              this.parentForm = res;
              this.form.orderId = this.parentForm.id;
              this.isMember(this.parentForm.memberId);
            }
          })
          .catch(error => {});
      });
    },

    payWayFun(item, index) {
      this.dialogHide = false;
      this.form.payWay = item.payCode;
	  this.form.payWayDescription=item.payName;
      for (let i in this.payWayList) {
        this.$set(this.payWayList[i], "show", false);
      }
      this.$set(this.payWayList[index], "show", true);
      if (this.form.payWay == "wallet") {
        this.$api.post(this.$url.app.cashier.orderCalculate, {
            orderId: this.form.orderId,
            payWay: this.form.payWay
          })
          .then(res => {
            if (res) {
              this.parentForm = res;
            }
          })
          .catch(error => {});
      }
    },
    isMember(memberId) {
      this.$api
        .get(this.$url.paywaySet.list, {
          isMember: memberId != "" ? true : false
        })
        .then(res => {
          if (res) {
            this.payWayList = res;
            for (let i in this.payWayList) {
              if (i == 0) {
                this.form.payWay = this.payWayList[i].payCode;
				this.form.payWayDescription = this.payWayList[i].payName;
                this.$set(this.payWayList[i], "show", true);
              } else {
                this.$set(this.payWayList[i], "show", false);
              }
            }

            if (memberId != "") {
              this.$api
                .post(this.$url.orderInfo.orderCalculate, {
                  orderId: this.form.orderId,
                  payWay: this.payWayList[0].payCode
                })
                .then(res => {
                  if (res) {
                    this.parentForm = res;
                  }
                })
                .catch(error => {});
            }
          }
        });
    },
    payMoney(org) {
      if (org) {
        this.addEditShow = false;
        this.$emit("change", org);
      }
    },
    confirmMoney() {
      if (this.form.payWay == "wallet") {
        if (
          this.parentForm.merchantAppMemberVO.walletAmount <
          this.parentForm.realPayAmount
        ) {
          localStorage.setItem(
            "payMobile",
            JSON.stringify({
              id: this.orgForm.id,
              path: this.$route.path,
              mobile: this.orgForm.orderMemberVO.mobile,
              arr: this.orgForm
            })
          );
          this.$refs["topUpForm"].$emit("set", "0");
        } else {
          this.dialogHide = true;
        }
      } else {
        
        this.$api.post(this.$url.order.pay, encrypt(JSON.stringify(this.form)))
          .then(res => {
            if (res && res.constructor != Object) {
              localStorage.removeItem("payMobile");
              localStorage.removeItem("productFootBathForm");
              this.$refs["payEditForm"].$emit("set", res);
            }
          })
          .catch(error => {});
      }
    },
    savePay(org) {
      if (org != "") {
        this.form.payCheckType = org.payCheckType;
        this.form.verifyCode = org.verifyCode;
        this.$api
          .post(this.$url.order.pay, encrypt(JSON.stringify(this.form)))
          .then(res => {
            if (res && res.status != "fail") {
              // this.isPayWayHide = false;
              this.dialogHide = false;
              this.orderId = res;
              localStorage.removeItem("payMobile");
              this.$refs["payEditForm"].$emit("set", res);
            }
          })
          .catch(error => {});
      } else {
        this.dialogHide = false;
      }
    }
  }
};
</script>
<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../assets/css/edit.less";
.pay-mains {
  .titles-head {
    border-top: 0;
  }
  .totals-box {
    padding: 0 0.2rem;
    .detail {
      padding: 14px 20px;
      font-size: 1rem;
      .rows {
        margin-bottom: 0.2rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .amount {
          font-size: 0.3rem;
        }
        div {
          color: #ff892a;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .pay-methods {
    padding: 0.3rem;
    .methods {
      margin-right: 0.2rem;
      width: 138px;
      height: 108px;
      background-color: #ececed;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .imgs {
        margin-bottom: 0.1rem;
        width: 30px;
        height: 30px;
      }
    }
    .active {
      background-image: url("../../assets/images/money/gou.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-color: @blue;
    }
  }
}
</style>